import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import Typography from "@mui/material/Typography";

import Stack from "@mui/material/Stack";

import { useHistory } from "react-router";
import { useParams } from "react-router-dom";
import { UserInfoGet } from "../../stores/Information";

const CallbackLogin = () => {
    const dispatch = useDispatch();
    const Params = useParams();
    const history = useHistory();

    useEffect(() => {
        const arg = {login_token: Params['id']};
        //パラメータのログイントークンから幹事データを取得しログイン処理する
        dispatch(UserInfoGet(arg)).then((data) => {
            if(data.payload.data.user_login)
            {
                console.log('ログイン完了');
                //ログイン処理完了済み　トップページへ
                history.push(`/`);
            }
            else
            {
                console.log('非ログイン');
                //会員登録ページへ
                history.push(`/EntranceUser`);
            }
        });
    }, [Params]);

    return (
        <>
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}
                sx={{
                    background: "#ffaf54",
                    pb: 2,
                }}
            >
                <Typography variant="h2" component="div">
                    CallbackLogin
                </Typography>
            </Stack>
        </>
    );
};

export default CallbackLogin;
